var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AgendaManage',{attrs:{"idFrom":_vm.$route.params.id != undefined ? _vm.$route.params.id : null,"reloadData":_vm.reloadData},on:{"saved":function($event){return _vm.redirectToList()},"voltar":function($event){return _vm.$router.push({ name: 'crm-agenda-list' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }